import apiClient from './apiClient';

const getExtraFieldsForGuest = async (guestId) => {
    const response = await apiClient.get(`/guest_extra_fields.php?guest_id=${guestId}`);
    return response.data;
};

const getAllFieldNames = async () => {
    const response = await apiClient.get('/guest_extra_fields.php');
    return response.data;
};

const upsertExtraField = async (guestId, fieldName, fieldValue) => {
    const response = await apiClient.post('/guest_extra_fields.php', {
        action: 'upsert',
        guest_id: guestId,
        field_name: fieldName,
        field_value: fieldValue,
    });
    return response.data;
};

const deleteFieldGlobally = async (fieldName) => {
    const response = await apiClient.post('/guest_extra_fields.php', {
        action: 'delete_field',
        field_name: fieldName,
    });
    return response.data;
};

export { getExtraFieldsForGuest, getAllFieldNames, upsertExtraField, deleteFieldGlobally };
